module.exports = __webpack_public_path__ + "img/perangkatsvg.aa97d905.svg";